// extracted by mini-css-extract-plugin
module.exports = {"icon":"SelectDropDown_icon__xdm4G","active":"SelectDropDown_active__4VnTV"};